import { images } from "../assets/Images/assetsImages";
import MainLayout from "../components/SharedComponents/MainLayout";
import HeroSection from "../components/CategoryPageComponents/HeroSection";
import ProductsSection from "../components/CategoryPageComponents/ProductsSection";
import CustomerFavSection from "../components/CategoryPageComponents/CustomerFavSection";

export default function PiesTartsPage() {

    const heroData = [
        {
          title: "Pies & Tarts",
          content: "Indulge in our pies and tarts, where buttery crusts meet decadent fillings. Whether sweet or savory, each one is baked to perfection and bursting with flavor.",
          image: images.PiesTartsHeroImage, 
        },
      ];

    const productData = [
      {
        name: "Dutch Apple Pie",
        content: "A classic pie filled with spiced apples, topped with a buttery crumb",
        price: 0,
        image: [
          images.Pie1,
        ]
      },
      {
        name: "Salted Pecan Pie",
        content: "Sweet and nutty pecan filling, balanced with a hint of salt",
        price: 0,
        image: [
          images.Pie2,
        ]
      },
      {
        name: "Blueberry Pie",
        content: "Juicy blueberries baked into a golden crust",
        price: 0,
        image: [
          images.Pie1,
        ]
      },
      {
        name: "Lemon Meringue Pie",
        content: "Zesty lemon filling nestled in a buttery, flaky crust, topped with a light and flu y golden meringue",
        price: 0,
        image: [
          images.Pie2,
        ]
      },
      {
        name: "Peach sour cream galette",
        content: "Moist sour cream cake topped with juicy peaches in a buttery galette",
        price: 0,
        image: [
          images.Pie1,
        ]
      },
      {
        name: "Fruit Tart",
        content: "Crisp tart shell filled with cream, topped with assorted fresh fruits",
        price: 0,
        image: [
          images.Pie2,
        ]
      },
      {
        name: "Blueberry Walnut Tart",
        content: "Tart filled with blueberries and crunchy walnuts",
        price: 0,
        image: [
          images.Pie1,
        ]
      },
    ]

    const customerFavData = [
      {
        name1: "Dutch Apple Pie",
        image1: [
          images.Pie1,
        ],
        content1: "A classic pie filled with spiced apples, topped with a buttery crumb",
        name2: "Salted Pecan Pie",
        image2: [
          images.Pie2,
        ],
        content2: "Sweet and nutty pecan filling, balanced with a hint of salt"
      },
    ]

    return (
      <div className="relative w-full min-h-screen bg-[#C3D7A4] bg-opacity-60">
        <MainLayout>
            <HeroSection heroData={heroData} />
            <ProductsSection productData={productData} />
            <CustomerFavSection customerFavData={customerFavData} />
        </MainLayout>
      </div>
    );
  }
  
